export const GET_MUNDIAL_TEAMS = 'GET_MUNDIAL_TEAMS';
